exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:flex;flex-direction:column;margin-bottom:2rem}:host h3{font-weight:600;font-family:Open Sans;margin:1.5rem 0}:host li{display:list-item;font-weight:600;line-height:1.5rem;cursor:pointer;text-align:left;text-decoration:underline}:host ul{list-style-type:disc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/faq/faq-summary/faq-summary.component.scss
// module id = 690
// module chunks = 0